import { Loader2 } from "lucide-react"
import { cn } from "@/lib/utils"

interface AdminLoadingOverlayProps {
  visible: boolean
  children: React.ReactNode
  label?: string
  className?: string
}

/**
 * 包住表格/列表，當 visible 為 true 時顯示半透明遮罩 + spinner。
 * 用於 filter 重新載入時清楚告知使用者「資料正在更新」。
 */
export function AdminLoadingOverlay({
  visible,
  children,
  label = "載入中…",
  className,
}: AdminLoadingOverlayProps) {
  return (
    <div className={cn("relative", className)}>
      <div
        className={cn(
          "transition-opacity",
          visible && "opacity-40 pointer-events-none select-none",
        )}
        aria-busy={visible}
      >
        {children}
      </div>
      {visible && (
        <div
          className="absolute inset-0 flex items-center justify-center pointer-events-none"
          role="status"
          aria-live="polite"
        >
          <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background/95 border shadow-md text-sm text-foreground">
            <Loader2 className="h-4 w-4 animate-spin text-primary" />
            <span>{label}</span>
          </div>
        </div>
      )}
    </div>
  )
}
